import { render } from "./App.vue?vue&type=template&id=d14fd84a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d14fd84a&lang=css"

import exportComponent from "/home/marilena/VSProjects/sourdough-second/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__